import React, { useState } from "react";
import { useAuth } from "../hooks/useAuth";

// Modal that shows when ?reset-password-token=... is in the URL.
// Lets the user enter and confirm a new password to consume the token.
const ResetPasswordModal = ({ token, onClose }) => {
  const { resetPassword } = useAuth();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  if (!token) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (!password || password.length < 8) {
      setError("Password must be at least 8 characters");
      return;
    }
    if (password !== confirm) {
      setError("Passwords do not match");
      return;
    }
    setLoading(true);
    try {
      await resetPassword(token, password);
      setSuccess(true);
    } catch (err) {
      setError(err.message || "Reset failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="relative p-6 rounded-lg shadow-xl w-96 max-w-md mx-4 glass-card bg-forest-800 text-forest-100">
        <button
          onClick={onClose}
          className="absolute top-2 right-2 text-lg w-6 h-6 flex items-center justify-center hover:opacity-70 transition-opacity"
          aria-label="Close"
        >
          ×
        </button>

        {success ? (
          <div className="text-center space-y-4">
            <h2 className="text-xl">Password updated</h2>
            <p className="text-sm text-forest-300">
              You can now sign in with your new password.
            </p>
            <button
              onClick={onClose}
              className="w-full py-2 rounded-md font-medium bg-gold-500 hover:bg-gold-400 text-forest-950 transition-colors"
            >
              Continue
            </button>
          </div>
        ) : (
          <>
            <h2 className="text-xl mb-4 text-center">Set a new password</h2>
            <form onSubmit={handleSubmit} className="space-y-4">
              <input
                type="password"
                placeholder="New password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-gold-500 bg-forest-700 border-forest-600 text-forest-100 placeholder-forest-300"
                disabled={loading}
                autoFocus
                required
              />
              <input
                type="password"
                placeholder="Confirm new password"
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-gold-500 bg-forest-700 border-forest-600 text-forest-100 placeholder-forest-300"
                disabled={loading}
                required
              />
              {error && <div className="text-ember-500 text-sm">{error}</div>}
              <button
                type="submit"
                disabled={loading}
                className="w-full py-2 rounded-md font-medium bg-gold-500 hover:bg-gold-400 text-forest-950 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
              >
                {loading ? "Saving…" : "Update password"}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
};

export default ResetPasswordModal;
